export const milestoneStatus = {
  COMPLETE: 'Complete',
  INCOMPLETE: 'Incomplete',
};

export const viewType = {
  TABLE: 'table',
  CARD: 'card',
};
